<template>
  <span class="quiz_point">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'QuizHeaderText'
}
</script>

<style scoped>
  .quiz_point {
    font-size: 30px;
    position: absolute;
    left: 40px;
    bottom: 20px;
  }

  @media screen and (max-width: 767px) {
    .quiz_point {
      position: relative;
      text-align: center;
      left: 0;
      bottom: 0;
      width: 65%;
      font-size: 24px;
    }
  }

</style>
